import React from 'react';
import { Points } from 'components/Points/Points';
import './CardGroupHeader.css';

interface CardGroupHeaderProps {
  title: string;
  lowPrice?: number;
  highPrice?: number;
  totalValue?: number;         // For Send Cards page
  autoMatch?: boolean;         // For Send Cards page
  onAutoMatchToggle?: (val: boolean) => void;
  mode?: 'printings' | 'send'; // Determines which header to render
}

const CardGroupHeader: React.FC<CardGroupHeaderProps> = ({
  title,
  lowPrice,
  highPrice,
  totalValue,
  autoMatch = false,
  onAutoMatchToggle,
  mode = 'printings',
}) => {
  return (
    <div className="card-group-header">
      <span className="header-title">{title}</span>

      {mode === 'printings' && (
        <div className="header-prices">
          <div className="price-item">
            <span className="price-label">Low</span>
            <Points points={lowPrice || 0} type="small" />
          </div>
          <div className="price-item">
            <span className="price-label">High</span>
            <Points points={highPrice || 0} type="small" />
          </div>
        </div>
      )}

      {mode === 'send' && (
        <div className="header-prices">
          <div className="price-item auto-match-container">
            <span className="price-label">🚧 Auto-Match</span>
            <label className="auto-match-toggle">
              <input
                type="checkbox"
                checked={autoMatch}
                onChange={(e) => onAutoMatchToggle?.(e.target.checked)}
              />
              <span className="toggle-slider" />
            </label>
          </div>
          <div className="price-item">
            <Points points={totalValue || 0} type="small" />
          </div>
        </div>
      )}
    </div>
  );
};

export default CardGroupHeader;
